import {Http, Headers} from '@angular/http';
import {RequestOptionsArgs, RequestMethod} from "@angular/http";
import {Injectable, Inject} from '@angular/core';
import {URLSearchParams} from '@angular/http';
import {Storage} from '@ionic/storage';
import {Subject, ReplaySubject} from 'rxjs/Rx';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class HttpInterceptor2 {
  authObs:Subject<string> = new ReplaySubject<string>(1);

  constructor(@Inject(Http) public http, public sql:Storage) {
    this.http = http;
    this.refreshAuth();
  }


  getApiToken(): Observable<Headers> {
    return Observable.fromPromise(this.sql.get('token'));
  }

  //Load the Subject
  refreshAuth() {
    return this.sql.get("token").then((token)=>{
      let auth ="";

      if(token!== "" && token!==undefined && token!==null) {
        auth=token;
      }

      let authHeader = 'Bearer ' + auth;
      return this.authObs.next(authHeader);
    });
  }

  getHeaders(): Headers {
    return new Headers({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    });
  }

  get(url: string): Observable<any> {
    let headers: Headers = this.getHeaders();
    let options: RequestOptionsArgs;
    options = {
      search: new URLSearchParams("Format=json"),
      method: RequestMethod.Get
    };
    options.headers = new Headers();

    return this.getApiToken().flatMap(token=>{
      headers.append('Authorization', 'Bearer ' + token);

      return this.http.get(url, { headers : headers })
        .map(res =>  res.json())
        .catch(this.handleError);
    })
  }

  post(url:string, data:string): Observable<any> {
    let headers: Headers = this.getHeaders();
    let options: RequestOptionsArgs;
    options = {
      search: new URLSearchParams("Format=json"),
      method: RequestMethod.Post
    };
    options.headers = new Headers();

    return this.getApiToken().flatMap(token=>{
      headers.append('Authorization', 'Bearer ' + token);

      return this.http.post(url, data, { headers : headers })
        .map(res =>  res.json())
        .catch(this.handleError);
    })
  }

  private handleError(error: any) {
    return Observable.throw(error || 'Server error');
  }
}



// WEBPACK FOOTER //
// ./src/services/HttpInterceptor.service.ts